/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Confirm_TitleInputs */

const en_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure?`)
};

const de_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher?`)
};

const fr_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es-tu sûr ?`)
};

const es_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas seguro?`)
};

const it_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro?`)
};

const nl_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weet je het zeker?`)
};

const pl_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy na pewno?`)
};

const fi_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oletko varma?`)
};

const da_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er du sikker?`)
};

const sv_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Är du säker?`)
};

/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Cancel_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_confirm_title = /** @type {((inputs?: Cancel_Confirm_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Confirm_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_confirm_title(inputs)
	if (locale === "fr") return fr_cancel_confirm_title(inputs)
	if (locale === "es") return es_cancel_confirm_title(inputs)
	if (locale === "it") return it_cancel_confirm_title(inputs)
	if (locale === "nl") return nl_cancel_confirm_title(inputs)
	if (locale === "pl") return pl_cancel_confirm_title(inputs)
	if (locale === "fi") return fi_cancel_confirm_title(inputs)
	if (locale === "da") return da_cancel_confirm_title(inputs)
	if (locale === "sv") return sv_cancel_confirm_title(inputs)
	return en_cancel_confirm_title(inputs)
});